import React, { useContext } from 'react';
import clsx from 'clsx';
import AccordionContext from 'react-bootstrap/AccordionContext';

import Img from '@common/Image';

import * as styles from '@styles/modules/block.module.scss';

const AccordionIcon = ({
  image,
  file,
  eventKey }) => {
  const { activeEventKey } = useContext(AccordionContext);
  const isCurrentEventKey = activeEventKey === eventKey;
  return (
    <div className={clsx('col-6 col-lg-5', styles.accordionIcon)}>
      <Img
        image={image}
        file={file}
        className={`${isCurrentEventKey ? 'fade-in' : 'd-none'}`}
      />
    </div>
  )
}

export default AccordionIcon
